/** @module SpecificationSourcing/SpecificationDataSheetRenderer */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,csi,Action,ViewRef,Ref,xml,Query) {

	return declare(Ref, {

		/**
		 * @override
		 * If the SRLineItem-Data Package-DataPackageTemplate is supplier-specific then only display Spec TDS
		 * with ForProductSource empty OR ForProductSource == this SRLineItem.SRLIProductSource
		 */
		_getStoreAction: function(ctx, h, bAll) {
			const cache = ctx.cache;
			const srli = ctx.getNode();

			const datapkg = srli && cache.get(srli.SRLineItemPackage);
			const template = datapkg && cache.get(datapkg.Template);
			const isSupplierSpecific = template && template.IsSupplierSpecific;

			if (srli && isSupplierSpecific) {
				let ps = srli.SRLIProductSources[0];
				let query = new Query();
				query.Or()
				.RefAttr("ForProductSource", xml.OP_EQUALS, csi.EMPTY_URL)
				.RefAttr("ForProductSource", xml.OP_EQUALS, ps);
				return lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "ForSpecificationDataSheet",
						m_url: srli.$URL
					}),
					m_fixedQuery: query
				});
			}

			return this.inherited(arguments);
		}
	});
});